// A cow, modelled facing +X: a big white body with brown patches, a blocky
// head with small horns, on four legs. Ported 1:1 from age-of-mcp's classic
// cow.ts, restoring its leg loop + body composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.07, 0.045], [0.07, -0.045], [-0.07, 0.045], [-0.07, -0.045]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.011, 0.01, 0.13, 4),
      color: "#3a2a1c", position: [x!, 0.065, z!] });
  }
  parts.push(
    { geometry: new THREE.BoxGeometry(0.17, 0.085, 0.085), color: "#f2ede4",
      position: [0, 0.13, 0] },                                        // body
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#5a3c24",
      position: [0.03, 0.155, 0.03], scale: [1.4, 0.8, 1] },          // brown patch
    { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#5a3c24",
      position: [-0.05, 0.12, -0.035], scale: [1.3, 0.9, 1] },        // brown patch
    { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.055), color: "#efe7da",
      position: [0.11, 0.14, 0] },                                     // head
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#f4b8c0",
      position: [0.137, 0.128, 0] },                                  // muzzle
    { geometry: new THREE.ConeGeometry(0.007, 0.018, 4), color: "#e8e0d0",
      position: [0.1, 0.172, 0.022] },                               // horn
    { geometry: new THREE.ConeGeometry(0.007, 0.018, 4), color: "#e8e0d0",
      position: [0.1, 0.172, -0.022] },
  );
  return parts;
}

export const cow = defineModel({
  id: "cow",
  scale: 3.13, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Cow",
  tags: ["creature","cow","low-poly","age-of-mcp","classic"],
  summary: "Low-poly cow.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.16,
  fits: ["draft"],
  parts: () => partsFor(),
  animations: [],
});
